import { memo } from 'react';
import { Typography } from 'antd';

import { Auction } from 'models/auction/Auction';
import ShippingList from 'pages/auctions/AuctionDetail/components/ShippingList/ShippingList';

const { Title } = Typography;

interface AuctionShippingProps {
  auction: Auction;
}

function AuctionShipping({ auction }: AuctionShippingProps) {
  return (
    <>
      <Title level={4}>배송 정보</Title>
      <ShippingList shippings={auction.shipping_methods} />
    </>
  );
}

export default memo(AuctionShipping);
